import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const PreferencesContext = createContext(null);

export const PreferencesProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('portfolio-theme') || 'light');
  const [language, setLanguage] = useState(() => localStorage.getItem('portfolio-language') || 'tr');

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.lang = language;
    localStorage.setItem('portfolio-language', language);
  }, [language]);

  const value = useMemo(() => ({ theme, setTheme, language, setLanguage }), [theme, language]);
  return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>;
};

export const usePreferences = () => useContext(PreferencesContext);
